import * as React from "react";
import AuthService from "../../services/authService";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import Translate from "../../common/functions/translate";
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import { withRouter } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import RegionService from '../../services/regionService';

interface IProps {
  history: any;
  onUserLogout: any;
}

interface IState {
  anchorEl: any;
}

class UserMenuComponent extends React.Component<IProps, IState> {
  authService = new AuthService();
  regionService = new RegionService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  componentDidMount() {

  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  handleClickProfile = () => {
    this.setState({ anchorEl: null }, () => this.props.history.push('/userprofile'))
  }

  handleClickLogout = () => {
    this.setState({ anchorEl: null }, () => {
      this.authService.logout()
      this.props.onUserLogout()
      this.props.history.replace('/login');
    })
  }

  returnUserRegionName = () => {
    return this.authService.getUserRegionName();
  }

  render() {
    const regionName = this.returnUserRegionName();

    return (
      <>
        {this.authService.isAuthenticated()
          ? <div style={{ marginRight: "20px" }}>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClick}>
              <div style={{ textTransform: "none", color: "#777", display: "flex", alignItems: "center" }}>
                <Avatar style={{ width: "24px", height: "24px", fontSize: "1em", marginRight: "7px" }}>
                  <FontAwesomeIcon icon={faUser} />
                </Avatar>
                <span style={{ marginRight: "7px" }}>{this.authService.getUserName()} ({Translate(this.authService.getUserRole())}{regionName ? " - " + regionName : ''}) </span>
                <FontAwesomeIcon icon={faCaretDown} />
              </div>
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={this.state.anchorEl}
              keepMounted
              open={this.state.anchorEl ? true : false}
              onClose={this.handleClose}
            >
              <MenuItem onClick={this.handleClickProfile}>{Translate('Profile')}</MenuItem>
              <MenuItem onClick={this.handleClickLogout}>{Translate('Logout')}</MenuItem>
            </Menu>
          </div>
          : null}
      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    isUserLogged: state.common.isUserLogged
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(UserMenuComponent));
